import { Skeleton } from "@/components/ui/skeleton";

// Shapes copied from the real page (DiscoverLanding): a label pill, a 22px heading and a one-line
// description above each section; rails of 240 x 174 cards with two round arrows; a large block for
// the directory. Keep them in step with the page, or the screen jumps when it loads.

const SectionHead = ({ heading }: { heading: number }) => (
  <div className="mb-6">
    <Skeleton className="mb-3 h-6 w-24 rounded" />
    <Skeleton className="h-[26px] max-w-full rounded" style={{ width: heading }} />
    <Skeleton className="mt-2 h-4 w-72 max-w-full rounded" />
  </div>
);

const Rail = ({ titleWidth }: { titleWidth: number }) => (
  <section className="mb-2">
    <div className="mb-4 flex items-end justify-between gap-3">
      <Skeleton className="h-[22px] rounded" style={{ width: titleWidth }} />
      <div className="flex items-center gap-2">
        <Skeleton className="h-9 w-9 rounded-full" />
        <Skeleton className="h-9 w-9 rounded-full" />
      </div>
    </div>
    <div className="flex gap-3 overflow-hidden pb-2">
      {Array.from({ length: 6 }).map((_, i) => (
        <Skeleton key={i} className="h-[174px] w-[240px] shrink-0 rounded-2xl" />
      ))}
    </div>
  </section>
);

const DiscoverSkeleton = () => (
  <div className="min-h-screen" aria-busy="true" aria-label="Loading">
    <main className="pb-12">
      <div className="ernest-container pb-10 pt-[40px]">
        <Skeleton className="mb-1.5 h-8 w-64 rounded" />
        <Skeleton className="h-6 w-96 max-w-full rounded" />
      </div>

      <div className="ernest-container mx-0 my-0">
        <div className="mb-12 space-y-14">
          {/* Ask ernest: the heading and the big search card */}
          <section>
            <SectionHead heading={470} />
            <Skeleton className="h-[155px] w-full rounded-xl" />
          </section>

          {/* Curated for you: rails of cards */}
          <section>
            <SectionHead heading={380} />
            <div className="-mt-4">
              {/* Three rails, like the page while its collections load */}
              <Rail titleWidth={210} />
              <Rail titleWidth={260} />
              <Rail titleWidth={190} />
            </div>
          </section>

          {/* Full directory */}
          <section>
            <SectionHead heading={340} />
            {/* The directory card is dark on the page, so the stand-in is too */}
            <div className="rounded-2xl border border-[#0E1626] bg-[#0E1626] p-8 sm:p-9">
              <div className="flex flex-col gap-8 sm:flex-row sm:items-end sm:justify-between">
                <div className="min-w-0 space-y-6">
                  <Skeleton className="h-5 w-[560px] max-w-full bg-white/10" />
                  <div className="flex flex-wrap gap-x-10 gap-y-4">
                    {[0, 1, 2].map((i) => (
                      <div key={i} className="flex flex-col gap-2">
                        <Skeleton className="h-[22px] w-14 bg-white/10" />
                        <Skeleton className="h-2.5 w-16 bg-white/10" />
                      </div>
                    ))}
                  </div>
                </div>
                <Skeleton className="h-[46px] w-44 shrink-0 rounded-xl bg-white/10" />
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  </div>
);

export default DiscoverSkeleton;
